var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedallaThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 48,
    viewBox: "0 0 32 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_498_1578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.30233 11.5441L6.23256 3.7999L13.7674 1.28827V8.75339C14.0833 10.671 14.3536 11.5326 14.9535 12.7999C11.8535 13.2021 10.2688 13.8078 7.69767 15.5208C6.91639 14.3673 6.66943 13.5473 6.30233 11.5441Z",
    fill: "#D47835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7674 11.4743L25.8372 3.73013L18.3023 1.21851V8.68362C17.9865 10.6013 17.7161 11.4628 17.1163 12.7301C20.2163 13.1323 21.801 13.738 24.3721 15.4511C25.1534 14.2975 25.4003 13.4775 25.7674 11.4743Z",
    fill: "#AF6835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 15.4511C9.37258 15.4511 4 20.8236 4 27.4511C4 31.0275 5.56453 34.2384 8.04651 36.4369L9.64147 33.7215C8.05124 32.109 7.06977 29.8947 7.06977 27.4511C7.06977 22.519 11.068 18.5208 16 18.5208C16.8247 18.5208 17.6232 18.6326 18.3814 18.8419L19.9767 16.1257C18.7322 15.6887 17.3939 15.4511 16 15.4511Z",
    fill: "#D47835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 39.4511C22.6274 39.4511 28 34.0785 28 27.4511C28 22.2175 24.6497 17.7665 19.9767 16.1257L18.3814 18.8419C22.1573 19.884 24.9302 23.3437 24.9302 27.4511C24.9302 32.3831 20.932 36.3813 16 36.3813C13.5116 36.3813 11.2609 35.3635 9.64147 33.7215L8.04651 36.4369C10.1639 38.3124 12.949 39.4511 16 39.4511Z",
    fill: "#AF6835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 36.3813C20.932 36.3813 24.9302 32.3831 24.9302 27.4511C24.9302 23.3437 22.1573 19.884 18.3814 18.8419L9.64147 33.7215C11.2609 35.3635 13.5116 36.3813 16 36.3813Z",
    fill: "#D47835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 18.5208C11.068 18.5208 7.06977 22.519 7.06977 27.4511C7.06977 29.8947 8.05124 32.109 9.64147 33.7215L18.3814 18.8419C17.6232 18.6326 16.8247 18.5208 16 18.5208Z",
    fill: "#AF6835"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6365 32.5266C15.1085 32.5266 14.6685 32.4266 14.3165 32.2266C13.9645 32.0266 13.7005 31.7386 13.5245 31.3626C13.3485 30.9866 13.2605 30.5426 13.2605 30.0306V29.7066H14.5325C14.5325 29.7386 14.5325 29.7746 14.5325 29.8146C14.5325 29.8466 14.5325 29.8826 14.5325 29.9226C14.5405 30.2106 14.5725 30.4706 14.6285 30.7026C14.6925 30.9346 14.8005 31.1186 14.9525 31.2546C15.1125 31.3906 15.3405 31.4586 15.6365 31.4586C15.9485 31.4586 16.1845 31.3866 16.3445 31.2426C16.5045 31.0906 16.6125 30.8786 16.6685 30.6066C16.7245 30.3346 16.7525 30.0226 16.7525 29.6706C16.7525 29.1586 16.6565 28.7426 16.4645 28.4226C16.2805 28.0946 15.9525 27.9146 15.4805 27.8826C15.4565 27.8746 15.4245 27.8706 15.3845 27.8706C15.3525 27.8706 15.3245 27.8706 15.3005 27.8706V26.5866C15.3245 26.5866 15.3525 26.5866 15.3845 26.5866C15.4165 26.5866 15.4445 26.5866 15.4685 26.5866C15.9245 26.5706 16.2525 26.4506 16.4525 26.2266C16.6525 26.0026 16.7525 25.6306 16.7525 25.1106C16.7525 24.6706 16.6765 24.3186 16.5245 24.0546C16.3805 23.7906 16.0885 23.6586 15.6485 23.6586C15.2085 23.6586 14.9165 23.8066 14.7725 24.1026C14.6285 24.3906 14.5485 24.7626 14.5325 25.2186C14.5325 25.2506 14.5325 25.2866 14.5325 25.3266C14.5325 25.3586 14.5325 25.3906 14.5325 25.4226H13.2605V25.0986C13.2605 24.5786 13.3485 24.1346 13.5245 23.7666C13.7005 23.3986 13.9645 23.1146 14.3165 22.9146C14.6765 22.7146 15.1205 22.6146 15.6485 22.6146C16.1845 22.6146 16.6285 22.7146 16.9805 22.9146C17.3325 23.1146 17.5965 23.4026 17.7725 23.7786C17.9485 24.1466 18.0365 24.5906 18.0365 25.1106C18.0365 25.6946 17.9085 26.1626 17.6525 26.5146C17.4045 26.8666 17.0685 27.1066 16.6445 27.2346C16.9405 27.3226 17.1885 27.4746 17.3885 27.6906C17.5965 27.9066 17.7565 28.1826 17.8685 28.5186C17.9805 28.8466 18.0365 29.2306 18.0365 29.6706C18.0365 30.2466 17.9565 30.7506 17.7965 31.1826C17.6365 31.6066 17.3805 31.9386 17.0285 32.1786C16.6765 32.4106 16.2125 32.5266 15.6365 32.5266Z",
    fill: "#262626"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_498_1578",
    x: 0,
    y: 1.21851,
    width: 32,
    height: 46.2325,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_498_1578"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_498_1578",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedallaThree);
export default __webpack_public_path__ + "static/media/MedallaThree.7ddb8ed8d1b13bb3495fe730f259cb72.svg";
export { ForwardRef as ReactComponent };